// Origen de la API en produccion (P2-5). Modulo puro (sin window ni axios) para poder probarlo con node --test.

/** Origenes permitidos en produccion, exactos (sin comodin de subdominios). */
export const ALLOWED_PROD_ORIGINS = ['https://synclyst.com'];

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0', '[::1]'];

/** true si la URL apunta a localhost o al puerto 8000 del backend; un valor que no se puede interpretar cuenta como true. */
export const isLocalOrBackendPort = (url: string, origin: string): boolean => {
  try {
    const u = new URL(url, origin);
    return u.port === '8000' || LOCAL_HOSTS.includes(u.hostname);
  } catch {
    return true;
  }
};

/** Allowlist de produccion: mismo origen (incluye rutas relativas como /api) o el apex exacto https://synclyst.com.
 *  Nunca subdominios (api.synclyst.com), localhost, el puerto 8000, http, dominios parecidos, usuario/contrasena ni valores malformados. */
export const isAllowedProdApiUrl = (url: string, origin: string): boolean => {
  if (!url || isLocalOrBackendPort(url, origin)) return false;
  try {
    const u = new URL(url, origin);
    if (u.username || u.password) return false;
    if (u.origin === new URL(origin).origin) return true;
    return ALLOWED_PROD_ORIGINS.includes(u.origin);
  } catch {
    return false;
  }
};
